import { Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';

export default class DistributionType extends TemporalEntity {
    static typeName = "DistributionType";

    constructor() {
        super();
        this.makeObservable();
    }

    public distributionTypeId: number = 0;

    @Rules.Required()
    public name: string = "";

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<DistributionType>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.name) {
            return "New distribution type";
        } else {
            return this.name;
        }
    }
}